import { useEffect, useState } from "react";
import useManageApi from "../../../hooks/useManageApi";
import { LoadingButton, LoadingComponent } from "usbc-web-react-library";
import './TrainingStepByStep.css'
import ValidationErrors from "../../shared/ValidationErrors";


const TrainingStepByStep = () => {
    const { getTrainingStepByStep, loading: trainingStepByStepLoading } = useManageApi();
    const { loadCoursePlayerUrl, loading: coursePlayerLoading } = useManageApi();
    const [trainingStepByStepViewModel, setTrainingStepByStepViewModel] = useState(null);
    const [coursePlayerUrl, setCoursePlayerUrl] = useState(null);
    const [validationErrors, setValidationErrors] = useState(null);

    useEffect(() => {
        const currentUrl = new URL(window.location.href);
        const currentUrlParams = currentUrl.searchParams;
        const returnUrl = currentUrlParams.get('returnUrl');
        const urlParams = returnUrl ? { returnUrl: returnUrl } : null;

        getTrainingStepByStep(urlParams).then((result) => {
            setTrainingStepByStepViewModel(result.data);
            if(result.data?.returnUrl && result.data.returnUrl === "AcceptTermsAndConditions"){
                getCoursePlayerUrl();
            }
        });
    }, []);

    function getCoursePlayerUrl() {
        setValidationErrors(null);
        loadCoursePlayerUrl(
            { onError: (errors) => { setValidationErrors(errors); }}
        ).then((result) => {
            if (!result?.data && !validationErrors) {
                setValidationErrors(["Failed to retrieve course player information. If the error persists, please contact support."]);
                return;
            }
            setCoursePlayerUrl(result?.data);
        });
    }

    function handleStartTrainingButton() {
        if (coursePlayerUrl) {
            window.location.href = coursePlayerUrl;
        } else {
            getCoursePlayerUrl();
        }
    }

    //TODO: Limit button on either request call time or 30 second lockout
    return (
        <LoadingComponent isLoading={() => trainingStepByStepLoading} description={"Loading... Please Wait."}>
            {validationErrors && <ValidationErrors className="validation-errors alert alert-danger mt-3" validationErrors={validationErrors} />}

            <div className="tsbs-notice card container">
                <div className="text-start">
                    <label>SafeSport has a new training course player that we use for all training</label>
                </div>

                <div className=" text-start">
                    <ul>
                        <li style={{ color: "green" }}><strong>USBC is fully integrated with SafeSport so you will no longer need to log into their website or remember another password!</strong></li>
                        <li>SafeSport Terms and condition must be approved before you can take training or print your certificates.</li>
                        <li>Printing all your SafeSport certificates is done on BOWL.com in the Athlete Safety Portal.</li>
                        <li>After taking a training, you will be auto enrolled into your next training course after 305 days from your last training.</li>
                    </ul>
                </div>
            </div>

            {trainingStepByStepViewModel?.returnUrl && trainingStepByStepViewModel?.returnUrl === "AcceptTermsAndConditions" &&
                <>
                    <div className="tsbs-btn-start-training-container text-center">
                        <br />
                        <LoadingButton id="btnTraining" type="button"
                            className="btn btn-primary  btn-block"
                            onClick={handleStartTrainingButton}
                            loadingText='Preparing Training Session'
                            loading={coursePlayerLoading}
                        >
                            {validationErrors ? "Retry" : "Start your training"}
                        </LoadingButton>
                    </div>
                </>
            }
        </ LoadingComponent >
    );
}

export default TrainingStepByStep;